var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeesBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.087,
    height: 15.092,
    viewBox: "0 0 23.087 15.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13080",
    "data-name": "Group 13080",
    transform: "translate(-75.476 -329.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44591",
    "data-name": "Path 44591",
    d: "M67.176,74.108H62.747c-.573,0-.77-.194-.769-.763,0-1.2-.018-2.4.018-3.6a3.977,3.977,0,0,1,3.557-3.717,24.963,24.963,0,0,1,3.272,0A3.968,3.968,0,0,1,72.4,69.779c.036,1.225.017,2.452.014,3.678,0,.439-.237.65-.7.65q-2.265,0-4.529,0",
    transform: "translate(19.823 269.983)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44592",
    "data-name": "Path 44592",
    d: "M6.068,88.207a6.324,6.324,0,0,0-.261,2.241c.007.75,0,1.5,0,2.251v1.2c-.032,0-.119.01-.205.01H.751c-.54,0-.748-.2-.748-.732,0-.784-.01-1.568.012-2.351a2.846,2.846,0,0,1,2.674-2.706c.933-.029,1.867-.009,2.8,0a4.266,4.266,0,0,1,.579.088",
    transform: "translate(75.476 250.183)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44593",
    "data-name": "Path 44593",
    d: "M165.708,93.908c0-1.23-.006-2.428,0-3.625a5.89,5.89,0,0,0-.261-2.065,3.561,3.561,0,0,1,.567-.1c.967-.009,1.935-.033,2.9,0a2.848,2.848,0,0,1,2.58,2.591c.04.865.02,1.734.013,2.6,0,.376-.248.589-.658.592-.734,0-1.467,0-2.2,0h-2.942",
    transform: "translate(-72.957 250.183)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44594",
    "data-name": "Path 44594",
    d: "M13.926,22.111a2.9,2.9,0,0,1,2.9,2.908,2.9,2.9,0,1,1-5.8-.025,2.882,2.882,0,0,1,2.9-2.884",
    transform: "translate(65.608 309.22)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44595",
    "data-name": "Path 44595",
    d: "M86.9,5.807a2.9,2.9,0,1,1,2.893-2.92A2.9,2.9,0,0,1,86.9,5.807",
    transform: "translate(0.13 329)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44596",
    "data-name": "Path 44596",
    d: "M159.853,22.113a2.9,2.9,0,0,1,0,5.8,2.9,2.9,0,1,1,0-5.8",
    transform: "translate(-65.351 309.218)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesBlack);
export default __webpack_public_path__ + "static/media/Employees_black.8a7533ebe1b0d1334f8b2120176c139f.svg";
export { ForwardRef as ReactComponent };